<template>
    <div class="news-items" v-if="newsItems != null">
        <!-- {{actionsItems}} -->
        <div class="news-item" v-for="item in newsItems" :class="{animate : newsCardAnimate}">
            <!-- :to="'/news/' + cytTolat(item.title)" -->
            <router-link :to="{ name: 'news-card' , params:{'id' : item.slug}}" @click.native="startLoader">
                <div class="news-item-img">
                    <img :src="item.news_img" alt="">
                    <div class="news-date">
                        <span>{{correctDate(item.date)}}</span>
                    </div>
                </div>
                <div class="news-title">
                    <h2 v-html="item.title"></h2>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    export default {
        name: 'news-item',
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                lang: window.GlobalLang,
            }
        },
        methods: {
            cytTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8,10));
                var month = date.slice(5,7);
                var year = date.slice(0,4);
                var monthFont;
                var total;
                if (this.lang == 'kz/') {
                    if (month == '01') {
                        monthFont = 'Қаңтар'
                    } else if (month == '02') {
                        monthFont = 'Ақпан'
                    } else if (month == '03') {
                        monthFont = 'Наурыз'
                    } else if (month == '04') {
                        monthFont = 'Сәуiр'
                    } else if (month == '05') {
                        monthFont = 'Мамыр'
                    } else if (month == '06') {
                        monthFont = 'Маусым'
                    } else if (month == '07') {
                        monthFont = 'Шiлде'
                    } else if (month == '08') {
                        monthFont = 'Тамыз'
                    } else if (month == '09') {
                        monthFont = 'Қыркүйек'
                    } else if (month == '10') {
                        monthFont = 'Қазан'
                    } else if (month == '11') {
                        monthFont = 'Қараша'
                    } else if (month == '12') {
                        monthFont = 'Желтоқсан'
                    }
                } else if (this.lang == 'en/') {
                    if (month == '01') {
                        monthFont = 'January'
                    } else if (month == '02') {
                        monthFont = 'February'
                    } else if (month == '03') {
                        monthFont = 'March'
                    } else if (month == '04') {
                        monthFont = 'April'
                    } else if (month == '05') {
                        monthFont = 'May'
                    } else if (month == '06') {
                        monthFont = 'June'
                    } else if (month == '07') {
                        monthFont = 'July'
                    } else if (month == '08') {
                        monthFont = 'August'
                    } else if (month == '09') {
                        monthFont = 'September'
                    } else if (month == '10') {
                        monthFont = 'October'
                    } else if (month == '11') {
                        monthFont = 'November'
                    } else if (month == '12') {
                        monthFont = 'December'
                    }
                } else {
                    if (month == '01') {
                        monthFont = 'Января'
                    } else if (month == '02') {
                        monthFont = 'Февраля'
                    } else if (month == '03') {
                        monthFont = 'Марта'
                    } else if (month == '04') {
                        monthFont = 'Апреля'
                    } else if (month == '05') {
                        monthFont = 'Мая'
                    } else if (month == '06') {
                        monthFont = 'Июня'
                    } else if (month == '07') {
                        monthFont = 'Июля'
                    } else if (month == '08') {
                        monthFont = 'Августа'
                    } else if (month == '09') {
                        monthFont = 'Сентября'
                    } else if (month == '10') {
                        monthFont = 'Октября'
                    } else if (month == '11') {
                        monthFont = 'Ноября'
                    } else if (month == '12') {
                        monthFont = 'Декабря'
                    }
                }
                
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
            setFilterNewsLength() {
                if (this.routerName != 'home') {
                    this.$store.commit('filterNewsItems', this.newsItemsDefault);
                }
            },
            startLoader() {
                if (this.routerName == 'home') {
                    this.$parent.$parent.$parent.$refs.topProgress.start();
                } else  {
                    this.$parent.$parent.$refs.topProgress.start();
                }
            }
        },
        computed: mapGetters({
            newsItems: 'loadNewsItems',
            newsCardAnimate: 'loadNewsCardAnimateStatus',
            newsItemsDefault: 'loadNewsItemsDefault',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.setFilterNewsLength();
            this.$store.watch(
                (state) => state.newsItemsFilter,
                (newValue) => {
                    if (newValue) {
                        this.setFilterNewsLength();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news-page/news-item.scss';
    @import '@/styles/components/news-page/respond/news-item-respond.scss';
</style>